import {DateTime} from "luxon";
import {isDate, isString} from "lodash";
import {isFirebaseTimestamp} from "./typeCheck";

export const gDate = date => {
    if (isFirebaseTimestamp(date))
        return date.toDate();
    else if (isDate(date))
        return date;
    else if (isString(date))
        return new Date(date);
    return null;
};

export const gfDate = date => {
    return date ? DateTime.fromJSDate(gDate(date)).toFormat('dd MMM yyyy') : '-- --- ----';
};

export const gfDatetime = date => {
    return date ? DateTime.fromJSDate(gDate(date)).toFormat('dd MMM yyyy HH:mm') : '-- --- ---- --:--';
};